import { Link } from 'react-router-dom';

const QuickLinksSection = ({ title, links, isMobile = false }) => {
    const content = (
        <>
            {isMobile && (
                <div className='social-links-heading'>
                    <div className="horz-line" />
                    <h2>{title}</h2>
                    <div className="horz-line" />
                </div>
            )}
            {!isMobile && <h3>{title}</h3>}
            <div className='quicklinks-links'>
                {links.map((link, index) => (
                    <Link key={index} to={link.to} className="footer-link">
                        {link.label}
                    </Link>
                ))}
            </div>
        </>
    );

    return (
        <div className="quicklinks">
            {content}
        </div>
    );
};

export default QuickLinksSection;